module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "navbar navbar-default navbar-fixed-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     \n    "), _c('center', [_vm._v("Design & Development by "), _c('a', {
    attrs: {
      "href": "http://www.dreamstudio.pt",
      "target": "_blank"
    }
  }, [_vm._v("DreamStudio")]), _vm._v(" | © " + _vm._s(_vm.ano) + " "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(_vm._s(_vm.evento))])]), _vm._v("\n     \n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abce55b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/Footer.vue
// module id = 258
// module chunks = 1